import { Component, OnInit } from '@angular/core';
import { TesteeService } from '../shared/services/testee.service';
import { ApiResponse } from '../shared/models/apiResponse';
import { TesteeDTO } from '../shared/dtos/testee.dto';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../shared/services/auth.service';

@Component({
    selector: 'app-topbar2',
    styles: [`
        img {
            width: 200px !important;
            position: relative;
            left: 20px;
        }
        `],
    templateUrl: './app.topbar2.component.html'
})
export class AppTopBar2Component implements OnInit {

    testeeId: string;  
    testee: TesteeDTO; 
     items!: MenuItem[]; 

    constructor(private testeeService: TesteeService,
        private authService: AuthService
    ) {
        this.items = [
            {
                label: 'Logout',
                icon: 'pi pi-power-off',
                command: () => {
                    this.authService.logout();
                }
            }
        ];
    }

    ngOnInit() {
        this.getTestee();
    }

    getTestee() {
        this.testeeService.getTestee().subscribe((data: ApiResponse) => {
            this.testee = data.result;
        });
    }
}
